export function getHost(req) {
  // Use DEV_HOST if available
  if (process.env.DEV_HOST) return process.env.DEV_HOST
  if (process.env.NODE_ENV === 'development') {
    // parse cookie
    const cookieHost = decodeURIComponent(
      ((req.headers.cookie || '').match(/dev_selected_catalog=([^;]*)/) ||
        '')[1] || ''
    )
    // use cookie data if development and available
    if (cookieHost) {
      return cookieHost
    }
  }
  // fallback to req.host
  return req.headers.host
}

export function getBaseUrl() {
  return process.env.BASE_URL + '/api/v1/'
}
